import { makeObservable, action, observable } from 'mobx'

class ResponseStatusStore {
  constructor () {
    this.reset()

    makeObservable(this, {
      // observables
      error404: observable,
      error403: observable,
      error401: observable,
      error500: observable,
      // actions
      setError404: action,
      setError403: action,
      setError401: action,
      setError500: action
    })
  }

  reset () {
    this.error404 = false
    this.error403 = false
    this.error401 = false
    this.error500 = false
  }

  setError404 () {
    this.error404 = true
  }

  setError403 () {
    this.error403 = true
  }

  setError401 () {
    this.error401 = true
  }

  setError500 () {
    this.error500 = true
  }
}

export default ResponseStatusStore
